import { defineStore } from 'pinia'
import api from '@/utils/api'

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    settings: null,
    loading: false,
    error: null,
    lastFetched: null
  }),
  getters: {
    needsRefresh: (state) => {
      // Refresh data if it's older than 10 minutes or if no data exists
      if (!state.lastFetched) return true
      const tenMinutesAgo = Date.now() - (10 * 60 * 1000)
      return state.lastFetched < tenMinutesAgo
    }
  },
  actions: {
    async fetchSettings(force = false) {
      // Don't fetch if already loading
      if (this.loading && !force) return
      
      // Don't fetch if data is fresh and not forcing
      if (!this.needsRefresh && !force && this.settings) return
      
      this.loading = true
      this.error = null
      try {
        const data = await api.get('/settings')
        this.settings = data
        this.lastFetched = Date.now()
      } catch (error) {
        this.error = error.message || 'Failed to fetch settings'
        // Only clear data if we don't have any existing data
        if (!this.settings) {
          this.settings = null
        }
      } finally {
        this.loading = false
      }
    }
  }
}) 